const STANDALONE_USER_KEY = "is_standalone_user";

export const isStandaloneUser = () =>
  localStorage.getItem(STANDALONE_USER_KEY) === "true";

export const markStandaloneUser = (isStandalone) => {
  localStorage.setItem(STANDALONE_USER_KEY, isStandalone ? "true" : "false");
};

export const clearStandaloneUser = () => {
  localStorage.removeItem(STANDALONE_USER_KEY);
};

